import React from 'react'
import { connect } from 'react-redux'
import { getFormValue, hasChangedValues } from '../../public/utility/formValues'
import { getListItems } from '../../public/utility'

class ExchangeRateListDiv extends React.Component {
    state = {}
    componentDidMount = () => {
        Tyan.doPostEvent({
            event: 'GetExchangeRateList',
            data: {},
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ initValues基本信息 })
            }
        })
    }

    handlerSave = () => {
        const { changedValues基本信息, } = this.state
        const { onSave, onClose } = this.props
        Tyan.doPostEvent({
            event: 'SaveExchangeRateList',
            data: { changedValues基本信息 },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('保存成功')
                onClose && onClose()
                onSave && onSave()
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '生效月份')
    }

    fieldset基本信息 = () => {
        const { list: 币别列表 } = getListItems(this, '基本信息', '币别列表')
        const p = { margin: '0px 5px 5px 5px', minWidth: 1, _full: true, flex: 1, clearable: false }
        return [
            { _text: '本币', minWidth: '45%', disabled: true },
            { _month: '生效月份', minWidth: '45%', },
            {
                _group: '', minWidth: '95%', items: [
                    {
                        _group: '', name: '标题', minWidth: '95%', items: [
                            { _label: '外币', minWidth: '45%', ...p, align: 'center' },
                            { _label: '汇率', minWidth: '45%', ...p, align: 'center' },
                        ]
                    }
                ].concat(币别列表 && 币别列表.map(({ id }) => {
                    const list = { listName: '币别列表', id }
                    return {
                        _group: '', minWidth: '95%', /* dynamicRender: true, */ items: [
                            { _text: '', name: '外币', list, minWidth: '45%', ...p, disabled: true },
                            { _float: '', name: '汇率', list, minWidth: '45%', ...p, decimals: 5 },
                        ]
                    }
                }))
            },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="700" minWidth="700"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(canSave && bChanged) },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                    { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(ExchangeRateListDiv)